export enum Resource {
  FULL = 'full',
  MIN = 'min',
  NAME = 'name',
}

export enum UnitConversionOperator {
  STATIC = 'STATIC',
  MULTIPLY = 'MULTIPLY',
  DIVIDE = 'DIVIDE',
}

export enum UomUnitType {
  UNIT = 'UNIT',
  MASS = 'MASS',
  LENGTH = 'LENGTH',
  VOLUME = 'VOLUME',
  AREA = 'AREA',
}

export enum SupplyMethod {
  NONE = 'NONE',
  BUY = 'BUY',
  PRODUCE = 'PRODUCE',
  RENTED = 'RENTED',
}

export enum ProductSource {
  LOCAL = 'LOCAL',
  IMPORT = 'IMPORT',
}

export enum ProductStatus {
  ACTIVE = 'ACTIVE',
  IN_DEVELOPMENT = 'IN_DEVELOPMENT',
  IN_AUDIT = 'IN_AUDIT',
  OBSOLETE = 'OBSOLETE',
  ARCHIVE = 'ARCHIVE',
  DELETE = 'DELETE',
}

export enum AuditStatus {
  NONE = 'NONE',
  IN_PROGRESS = 'APPROVED',
}

export enum UserRole {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
}

export enum MaterialIssuanceType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum PurchaseOrderStatusEnums {
  ALL = 'ALL',
  DRAFT = 'DRAFT',
  CONFIRM = 'CONFIRM',
  APPROVED = 'APPROVED',
  // READY = 'READY',
  // DONE = 'DONE',
  CANCEL = 'CANCEL',
}
export enum Currency {
  PHP = 'PHP',
  USD = 'USD',
}

export enum RequestStatusEnum {
  ALL = 'ALL',
  DRAFT = 'DRAFT',
  CONFIRM = 'CONFIRM',
  APPROVED = 'APPROVED',
  // WAITING = 'WAITING',
  AVAILABLE = 'AVAILABLE',
  READY = 'READY',
  ISSUED = 'ISSUED',
  // IN_TRANSIT = 'IN_TRANSIT',
  DONE = 'DONE',
  CANCEL = 'CANCEL',
  // DELETED = 'DELETED',
}

export enum BOMStatusEnum {
  ALL = 'ALL',
  CONFIRM = 'CONFIRM',
  APPROVED = 'APPROVED',
  READY = 'READY',
  DONE = 'DONE',
  CANCEL = 'CANCEL',
  AVAILABLE = 'AVAILABLE',
  DRAFT = 'DRAFT',
}

export enum MaterialRequestStatusEnum {
  ALL = 'ALL',
  DRAFT = 'DRAFT',
  CONFIRM = 'CONFIRM',
  APPROVED = 'APPROVED',
  WAITING = 'WAITING',
  AVAILABLE = 'AVAILABLE',
  READY = 'READY',
  ISSUED = 'ISSUED',
  IN_TRANSIT = 'IN_TRANSIT',
  DONE = 'DONE',
  CANCEL = 'CANCEL',
  DELETED = 'DELETED',
}

export enum RRPurposeEnum {
  NONE = 'NONE',
  INVENTORY_ONLY = 'INVENTORY_ONLY',
  PAYMENT_ONLY = 'PAYMENT_ONLY',
  PAYMENT_AND_INVENTORY = 'PAYMENT_AND_INVENTORY',
}

export enum PickingType {
  OUT = 'OUT',
  IN = 'IN',
  INTERNAL = 'INTERNAL',
  BOM = 'BOM',
}
